import { FC } from "react";
import { IconPropsType } from ".";

export const WhatsApp2: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3866_400)">
        <path
          d="M17.0858 2.90641C15.2057 1.03328 12.7057 0.00114284 10.0421 0C4.55341 0 0.0867123 4.44562 0.0845149 9.90993C0.0838754 11.6566 0.542278 13.3616 1.41358 14.8646L0.000915527 20L5.27955 18.622C6.73391 19.4116 8.37143 19.8277 10.0378 19.8284H10.0421H10.0421C15.5299 19.8284 19.9973 15.382 19.9996 9.91796C20.0005 7.2697 18.9657 4.77968 17.0858 2.90641ZM10.0421 18.1546H10.0389C8.55354 18.1538 7.09696 17.7568 5.82647 17.0062L5.52412 16.8278L2.39166 17.6454L3.22799 14.6059L3.03099 14.2942C2.20246 12.9827 1.76506 11.4669 1.76569 9.91057C1.76751 5.36881 5.48005 1.67389 10.0452 1.67389C12.256 1.6748 14.3338 2.53272 15.8964 4.08961C17.459 5.64649 18.319 7.71614 18.3183 9.91726C18.3164 14.4592 14.6037 18.1546 10.0421 18.1546Z"
          fill="#E0E0E0"
        />
        <path
          d="M0.457764 19.4302L1.8059 14.5294C0.974184 13.0951 0.536804 11.4678 0.537329 9.80126C0.53951 4.58666 4.80221 0.344238 10.0397 0.344238C12.5818 0.345381 14.9676 1.33032 16.7614 3.11793C18.5557 4.90553 19.5432 7.28165 19.5421 9.80865C19.5399 15.0234 15.277 19.2662 10.0401 19.2662C10.0397 19.2662 10.0404 19.2662 10.0401 19.2662H10.0359C8.44561 19.2657 6.88301 18.8682 5.49518 18.1152L0.457764 19.4302Z"
          fill="url(#paint0_linear_3866_400)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.58123 5.70264C7.39701 5.29485 7.20305 5.28669 7.02779 5.27955C6.88443 5.27343 6.72031 5.27381 6.55646 5.27381C6.39248 5.27381 6.126 5.33516 5.90065 5.58019C5.67517 5.82521 5.03973 6.41755 5.03973 7.62225C5.03973 8.82708 5.92115 9.99123 6.04401 10.1547C6.167 10.318 7.74548 12.8693 10.2453 13.8507C12.323 14.6664 12.7457 14.5042 13.1967 14.4634C13.6477 14.4225 14.6518 13.8711 14.8568 13.2993C15.0618 12.7277 15.0618 12.2376 15.0003 12.1352C14.9388 12.0331 14.7748 11.9719 14.5288 11.8495C14.2828 11.727 13.0737 11.1346 12.8482 11.0529C12.6227 10.9713 12.4588 10.9305 12.2948 11.1756C12.1308 11.4205 11.6597 11.9719 11.5162 12.1352C11.3727 12.2988 11.2293 12.3192 10.9833 12.1968C10.7373 12.074 9.94517 11.8157 9.00547 10.9815C8.27433 10.3325 7.78071 9.53099 7.63722 9.28585C7.49373 9.04096 7.62184 8.90831 7.74522 8.78624C7.85565 8.67654 7.9912 8.50039 8.11419 8.35741C8.23691 8.21442 8.27791 8.11238 8.3599 7.94912C8.44189 7.7856 8.4009 7.64263 8.3394 7.52018C8.27791 7.39773 7.79992 6.18681 7.58123 5.70264Z"
          fill="white"
        />
        <path
          d="M17.0042 2.87489C15.1456 1.02325 12.6743 0.00299022 10.0414 0.00183105C4.61565 0.00183105 0.20023 4.39642 0.198049 9.798C0.19741 11.5247 0.650549 13.2101 1.51185 14.6958L0.115417 19.7722L5.33346 18.41C6.77115 19.1906 8.38986 19.6019 10.0371 19.6026H10.0413H10.0414C15.4662 19.6026 19.8822 15.2072 19.8845 9.8059C19.8854 7.18809 18.8625 4.72665 17.0042 2.87489ZM10.0414 17.948H10.0382C8.56986 17.9473 7.12999 17.5548 5.8741 16.8128L5.57521 16.6364L2.47872 17.4447L3.30543 14.44L3.1107 14.132C2.29168 12.8355 1.8593 11.3371 1.85994 9.79865C1.86172 5.30904 5.53165 1.65654 10.0444 1.65654C12.2298 1.65743 14.2837 2.5055 15.8285 4.04452C17.3732 5.58354 18.2232 7.62942 18.2225 9.80529C18.2206 14.295 14.5505 17.948 10.0414 17.948Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3866_400"
          x1="9.99995"
          y1="19.4302"
          x2="9.99995"
          y2="0.34427"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#20B038" />
          <stop offset="1" stopColor="#60D66A" />
        </linearGradient>
        <clipPath id="clip0_3866_400">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
